import { render, staticRenderFns } from "./voucherInfo.vue?vue&type=template&id=6f4cf992&scoped=true"
import script from "./voucherInfo.vue?vue&type=script&lang=js"
export * from "./voucherInfo.vue?vue&type=script&lang=js"
import style0 from "./voucherInfo.vue?vue&type=style&index=0&id=6f4cf992&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4cf992",
  null
  
)

export default component.exports